import { useEffect, useState } from 'react';

/**
 * The current time as state, so a render can read a clock without being impure.
 *
 * Needed by anything that shows whether a scheduled post has gone live yet: that answer
 * depends on the wall clock, and reading `Date.now()` during render gives React a value that
 * changes for reasons React cannot see (the `react-hooks/purity` rule rejects it, correctly).
 *
 * The interval is the other half of the point — a post scheduled for 09:00 flips from
 * "scheduled" to "live" on its own while the page sits open, instead of lying until someone
 * reloads.
 */
export function useNow(intervalMs = 30_000): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);

  return now;
}
